import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { TestimonialsWidget } from './TestimonialsWidget'

class HoldstyringTestimonialsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return TestimonialsWidget
  }

  // Supported HTML attributes:
  //   title="Hvad siger vores kunder"  — heading above the cards (default: none)
  //   max-items="6"                    — show only first N testimonials
  protected getWidgetProps() {
    const raw = this.getAttribute('max-items')
    return {
      title: this.getAttribute('title') || null,
      maxItems: raw && /^\d+$/.test(raw) ? parseInt(raw, 10) : null,
    }
  }
}

if (!customElements.get('holdstyring-testimonials')) {
  customElements.define('holdstyring-testimonials', HoldstyringTestimonialsElement)
}

export { HoldstyringTestimonialsElement }
